import { render, staticRenderFns } from "./VerifierWithRouter.vue?vue&type=template&id=1bc20b9d&"
import script from "./VerifierWithRouter.vue?vue&type=script&lang=js&"
export * from "./VerifierWithRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports